import { render, staticRenderFns } from "./LiveGameScorecard.vue?vue&type=template&id=69a35326&scoped=true&"
import script from "./LiveGameScorecard.vue?vue&type=script&lang=js&"
export * from "./LiveGameScorecard.vue?vue&type=script&lang=js&"
import style0 from "./LiveGameScorecard.vue?vue&type=style&index=0&id=69a35326&lang=scss&scoped=true&"
import style1 from "./LiveGameScorecard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a35326",
  null
  
)

export default component.exports